// Default status - can be overridden by API data
export const DEFAULT_STATUS = "Unknown/Pending";
